<template>
  <router-view class="animated fadeIn"
    :nested="nested"
    v-if="entity"
    :entity="entity"
    :http="http"></router-view>
</template>

<script>
  import { get } from 'lodash'
  import entities from '@/_entities'
  import { resolveHTTP } from '@/services/api'

  export default {
    data () {
      return {
        http: null,
        entity: null,
        parentEntity: null
      }
    },

    watch: {
      '$route' (to, from) {
        let next = get(to, 'path', null)
        let prev = get(from, 'path', null)

        if (next !== prev) {
          this.resolveEntity()
        }
      }
    },

    computed: {
      nested () {
        return (!!this.$route.params.nestedEntity) && get(this.$route, 'meta.nested', false)
      }
    },

    methods: {
      resolveEntity () {
        let entity

        if (this.nested) {
          this.parentEntity = entities[this.$route.params.entity]
          entity = entities[this.$route.params.nestedEntity]
        } else {
          entity = entities[this.$route.params.entity]
        }

        if (!entity) {
          this.$router.replace({ name: '404' })
        }

        if (entity) {
          this.entity = entity
          if (entity.api) {
            this.http = entity.api
          } else if (entity.url) {
            this.http = resolveHTTP(this.entity.url)
          }
        }

        if (!this.http) {
          // throw an error
        }
      }
    },

    created () {
      this.resolveEntity()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/manageables/Handler.vue